/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/event-pulse/react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import { SPECIALIZATION_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import _t from 'i18n!nls/xdp';

type Props = {
  courseCount: number;
  subtitle?: string;
};

const styles = {
  link: css`
    /* override cds link color */
    color: var(--cds-color-neutral-primary) !important;
  `,
  detailItemWrapper: css`
    display: inline-flex;
  `,
};

export const KeyInformationCourseCount = ({ courseCount, subtitle }: Props): React.ReactElement | null => {
  const eventingProductData = useEventingProductData();

  if (!courseCount) {
    return null;
  }

  return (
    <KeyInformationDetailsItem
      title={
        <TrackedDiv trackingName="kim_view_syllabus">
          <Link
            href={`#${SPECIALIZATION_NAV_ITEMS.COURSES}`}
            typographyVariant="subtitleLarge"
            trackingData={{
              button: { name: 'description_page_view_syllabus' },
              pageSection: {
                sectionName: 'kim',
              },
              ...eventingProductData,
            }}
            noViewTracking
            css={styles.link}
          >
            {_t('#{courseCount} course series', {
              courseCount,
            })}
          </Link>
        </TrackedDiv>
      }
      subtitle={subtitle ?? _t('Earn a career credential that demonstrates your expertise')}
    />
  );
};

export default KeyInformationCourseCount;
